$(document).ready(function () {
    $(".icon-search-desktop").on("click", function () {
        $(this).hide(), $(".search_container").slideDown().addClass("active");
    }),
        $(document).mouseup(function (e) {
            var t = $(".search_container");
            t.is(e.target) || 0 !== t.has(e.target).length || (t.hide(), $(".icon-search-desktop").show());
        })
    //,$("#modal").fancybox()
    ;
}),
    $(document).ready(function () {
        if ($(".type").length) new Typed(".type", { strings: ["Lash", "Brow"], loop: !0, typeSpeed: 200 });
        window.innerWidth < 799
            ? ($(".solution-product_section.active .js-product-gallery").flickity({
                  adaptiveHeight: !0,
                  wrapAround: "true",
                  cellAlign: "left",
                  contain: !0,
                  imagesLoaded: !0,
                  lazyLoad: 2,
                  pageDots: !1,
                  dragThreshold: 10,
                  arrowShape: { x0: 10, x1: 30, y1: 30, x2: 32, y2: 28, x3: 12 },
              }),
              $(".product-switcher").on("click", function () {
                  var e = $(this).data("id");
                  $(".product-switcher").removeClass("active"),
                      $(this).addClass("active"),
                      $(".solution-product_section").removeClass("active"),
                      $(".product-" + e).addClass("active"),
                      $(".solution-product_section.active .js-product-gallery").flickity({
                          adaptiveHeight: !0,
                          wrapAround: "true",
                          cellAlign: "left",
                          contain: !0,
                          imagesLoaded: !0,
                          lazyLoad: 2,
                          pageDots: !1,
                          dragThreshold: 10,
                          arrowShape: { x0: 10, x1: 30, y1: 30, x2: 32, y2: 28, x3: 12 },
                      });
              }))
            : $(".solution-product_section .js-product-gallery").flickity({
                  adaptiveHeight: !0,
                  wrapAround: "true",
                  cellAlign: "left",
                  contain: !0,
                  imagesLoaded: !0,
                  lazyLoad: 2,
                  pageDots: !1,
                  dragThreshold: 10,
                  prevNextButtons: !0,
                  arrowShape: { x0: 10, x1: 30, y1: 30, x2: 32, y2: 28, x3: 12 },
              }),
            window.innerWidth < 799 && $(".icons-containerr").flickity({ cellAlign: "left", contain: !0, wrapAround: !0, arrowShape: { x0: 10, x1: 30, y1: 30, x2: 32, y2: 28, x3: 12 } });
        var e = { freeScroll: !0, prevNextButtons: !0 };
        matchMedia("screen and (min-width: 799px)").matches && ((e.cellAlign = "center"), (e.contain = !0), (e.wrapAround = !1), (e.prevNextButtons = !0)), $(".home-blog-sliderr").flickity(e);
        $(".banner-slider").flickity({ fade: !0, pageDots: !1, prevNextButtons: !1, wrapAround: !0, autoPlay: 2e3 });
    }),
    $(document).ready(function () {
        function e() {
            var e = $(".jdgm-rev-widg").outerHeight(),
                t = $(".reviews-title").outerHeight();
            $(window).innerWidth() < 990 ? $(".reviews-ingredients-arrow").css("top", e + t + 30) : $(".reviews-ingredients-arrow").css("top", e + t + 10);
        }
        $(".related-product select").on("change", function () {
            let e;
            var t = $(this).find("option:selected").data("price"),
                i = $(this).find("option:selected").data("compare");
            i > t && (e = parseInt((100 * (i - t)) / i)),
                $(this)
                    .next(".v-price")
                    .html(
                        '<del class="old-price">' +
                            Shopify.formatMoney(i, $("body").data("money-format")) +
                            '</del><span class="bold-blue">' +
                            Shopify.formatMoney(t, $("body").data("money-format")) +
                            '</span><span class="solutions-product-discount">( Save ' +
                            e +
                            "%)</span>"
                    );
        }),
            window.innerWidth < 799 &&
                ($(".ingredient-container").flickity({ wrapAround: !0, arrowShape: { x0: 10, x1: 40, y1: 40, x2: 42, y2: 38, x3: 12 } }), $(".process-steps1").flickity({ wrapAround: !1, cellAlign: "left", prevNextButtons: !1 })),
            $(".ingredient-tab").on("click", function () {
                $(this).next(".ingredient-tab__content").slideToggle(), $(this).find(".ingredients-arrow ").toggleClass("active");
            }),
            $(".questions__title").on("click", function () {
                $(this).next(".questions__wrapper").slideToggle(), $(this).find(".ingredients-arrow ").toggleClass("active");
            }),
            $(".product-reviews").on("click", function () {
                $(this).find(".jdgm-rev-widg__body").slideToggle(), $(this).find(".ingredients-arrow").toggleClass("active");
            }),
            $(".jdgm-sort-dropdown").on("click", function (e) {
                e.stopPropagation();
            }),
            e(),
            $(window).on("resize", function () {
                e();
            });
        let t = $(".process-step").innerWidth() - $(".step-icon").innerWidth(),
            i = t / 4;
        window.innerWidth < 799 ? $(".step-line").css({ width: i }) : $(".step-line").css({ width: t }),
            $(".results-img img").length > 1 && $(".results-img").flickity({ arrowShape: { x0: 10, x1: 40, y1: 40, x2: 42, y2: 38, x3: 12 } }),
            window.innerWidth < 799 && $(".related-products_container").flickity({ pageDots: !1, prevNextButtons: !1 }),
            $(".results-arrows .prev-arrow").on("click", function () {
                $(".results-img .flickity-prev-next-button.previous").trigger("click");
            }),
            $(".results-arrows .next-arrow").on("click", function () {
                $(".results-img .flickity-prev-next-button.next").trigger("click");
            });
    });
$(document).ready(function () {
    $(".home-blog-slider").flickity({ wrapAround: true, pageDots: false, initialIndex: 1, accessibility: true, autoPlay: false });
    function initPromoSliders() {
        var time = $(".header").data("slide-time");
        if (window.innerWidth < 799) {
            $(".promo_banner--mobile").flickity({ autoPlay: time, prevNextButtons: false, pageDots: false, wrapAround: true, pauseAutoPlayOnHover: false, selectedAttraction: 0.01, friction: 0.15 });
        } else {
            $(".promo_banner--desktop").flickity({ autoPlay: time, prevNextButtons: false, pageDots: false, wrapAround: true, pauseAutoPlayOnHover: false, selectedAttraction: 0.01, friction: 0.15 });
        }
    }
    initPromoSliders();
    $(window).resize(initPromoSliders);
    if ($("body").hasClass("product-details")) {
        $(".product_section li").on("click", function () {
            $(this).parent().find("li").removeClass("active");
            $(this).addClass("active");
            var pr = $(this).find(".bold-blue").find("span").html();
            $("#shopify-section-product-details-template").find(".product_section .add_to_cart span.text span").html(pr);
            $(".sticky_price").find("span").html(pr);
        });
        $(window).scroll(function () {
            var scroll = $(window).scrollTop(),
                pglry = $(".prp_details").offset().top;
            if ($(window).width() <= 798) {
                if (scroll > pglry) {
                    $("body").addClass("gallery_hid");
                } else {
                    $("body").removeClass("gallery_hid");
                }
            }
        });
        moveDivisor();
        //$(".ver_tabs.result_mobile").slick();
        $(".ver_tabs.result_mobile").on("afterChange", function (event, slick, currentSlide, nextSlide) {
            var bf_img = $(slick.$slides[currentSlide]).data("before"),
                af_img = $(slick.$slides[currentSlide]).data("after");
            $("#comparison")
                .find("figure")
                .css("background-image", "url(" + af_img + ")");
            $("#comparison")
                .find("#divisor")
                .css("background-image", "url(" + bf_img + ")");
        });
        //$(".steps .process-steps").slick({ slidesToShow: 1, slidesToScroll: 1, mobileFirst: true, arrows: false, dots: true, centerMode: true, responsive: [{ breakpoint: 769, settings: "unslick" }] });
        $(".questions__item .questions-item__heading").click(function () {
            var self = $(this);
            if (self.siblings(".questions-item__text").is(":visible")) {
                self.siblings(".questions-item__text").slideUp();
                self.removeClass("qs_active");
            } else {
                $(".questions-item__heading").each(function () {
                    if ($(this).siblings(".questions-item__text").is(":visible")) {
                        $(this).siblings(".questions-item__text").slideUp();
                        $(".questions-item__heading").removeClass("qs_active");
                        self.removeClass("qs_active");
                    }
                });
                self.addClass("qs_active");
                self.next(".questions-item__text").slideDown();
            }
        });
    }
  /*
    let controller = new ScrollMagic.Controller();
    $(".bite-circle").each(function () {
        var spinText = new TimelineMax().add([TweenMax.fromTo($(this), 1, { rotation: 0 }, { rotation: 360, ease: Linear.easeNone })]);
        var textRotateScene = new ScrollMagic.Scene({ triggerElement: this, triggerHook: "onEnter", offset: 0, duration: $(window).height() * 2 }).setTween(spinText).addTo(controller);
    });
   */
});
function moveDivisor() {
    var divisor = document.getElementById("divisor"),
        slider = document.getElementById("slider"),
        range_wide = document.getElementById("range_wide");
    divisor.style.width = slider.value + "%";
    range_wide.style.width = slider.value + "%";
}
